import { render } from "./vue-qr.vue?vue&type=template&id=477c6f15"
import script from "./vue-qr.vue?vue&type=script&lang=js"
export * from "./vue-qr.vue?vue&type=script&lang=js"

import exportComponent from "C:\\codeupRepo\\iot\\equipment-management\\live-camera\\base-portal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__